export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    "Les codes promo et les cartes cadeaux ne peuvent pas être combinés avec d'autres réductions. Une offre et une utilisation de points peuvent être utilisées ensemble. Les réductions automatiques, comme la remise retrait, s'appliquent toujours.",
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: "Les codes promo et les cartes cadeaux ne peuvent pas être combinés avec d'autres réductions.",
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Débloqué',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Ne peut pas être combinée avec des codes promo ou des cartes cadeaux.',
    promo: 'Ne peut pas être combiné avec des offres, des cartes cadeaux ou des points.',
    gift: 'Ne peut pas être combinée avec des offres, des codes promo ou des points.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Un code promo est appliqué. Appliquer cette offre le supprimera.',
    offer_blocked_by_gift: 'Une carte cadeau est appliquée. Appliquer cette offre la supprimera.',
    offer_blocked_by_points: 'Une utilisation de points est active. Appliquer cette offre la supprimera.',
    promo_gift_displaces_offer: 'Appliquer un code promo ou une carte cadeau supprimera votre offre active.',
    promo_gift_displaces_points: 'Appliquer un code promo ou une carte cadeau supprimera votre utilisation de points.',
    promo_gift_displaces_offer_and_points:
      'Appliquer un code promo ou une carte cadeau supprimera votre offre active et votre utilisation de points.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Ce {{kind}} est déjà actif : {{name}} ({{saving}}).',
    active_line_no_saving: 'Ce {{kind}} est déjà actif : {{name}}.',
    candidate_line: 'Le {{kind}} économise {{saving}}.',
    only_one: "Vous ne pouvez en utiliser qu'un.",
    best_choice: 'Meilleur choix',
    keep: 'Garder {{label}}',
    use_instead: 'Utiliser {{label}} à la place',
    kinds: {
      offer: 'offre',
      promo: 'code promo',
      gift: 'carte cadeau',
      points: 'utilisation de points',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'offre',
      promo: 'code',
      gift: 'carte cadeau',
      points: 'points',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} est déjà actif. Une seule réduction peut être utilisée par commande — utilisez cette offre à la place, ou fermez cette fenêtre pour conserver votre code.',
    active_named: {
      promo: 'Code promo {{name}} ({{saving}})',
      gift: 'Carte cadeau ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Code promo {{name}}',
      gift: 'Carte cadeau',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Vous avez {{count}} offres actives : {{first}} ({{firstValue}}) et {{second}} ({{secondValue}}) — {{total}} ensemble. Le code promo {{code}} économise {{codeValue}} sur cette commande. Une seule peut être utilisée.',
    active_offers_more:
      'Vous avez {{count}} offres actives : {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) et {{more}} de plus — {{total}} ensemble. Le code promo {{code}} économise {{codeValue}} sur cette commande. Une seule peut être utilisée.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Disponible maintenant',
    applied: 'Appliqué · {{savings}} de réduction',
    applied_plain: 'Appliqué',
    replaces: 'Ne peut pas être combiné avec {{label}} · Remplace {{name}}',
    replaces_no_name: 'Ne peut pas être combiné avec {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Ne peut pas être combiné avec {{name}}',
    replaces_name: 'Remplace {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Ne peut pas être combiné avec vos {{count}} offres actives',
    replaces_offers: 'Remplace {{count}} offres actives ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'une offre',
      promo: 'un code promo',
      gift: 'une carte cadeau',
      points: 'votre utilisation de points',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} appliqué. Cela a supprimé {{removed}}.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Code promo {{code}} ({{codeValue}}) appliqué. Cela a supprimé {{count}} offres : {{first}} et {{second}} ({{total}}).',
      gift: 'Carte cadeau appliquée. Cela a supprimé {{count}} offres : {{first}} et {{second}} ({{total}}).',
    },
    undo: 'Annuler',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Offre {{name}}',
      promo: 'Code promo {{code}}',
      gift: 'Carte cadeau',
      points: '{{count}} points',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: "l'offre {{name}}",
      promo: 'le code promo {{code}}',
      gift: 'la carte cadeau',
      points: 'votre utilisation de points',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Utiliser des points supprimera le code promo {{name}} (–{{saving}})',
      gift: 'Utiliser des points supprimera la carte cadeau (–{{saving}})',
      promo_no_saving: 'Utiliser des points supprimera le code promo {{name}}',
      gift_no_saving: 'Utiliser des points supprimera la carte cadeau',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo:
        '{{points}} points appliqués (–{{pointsSaving}}). Le code promo {{name}} (–{{couponSaving}}) a été supprimé.',
      gift: '{{points}} points appliqués (–{{pointsSaving}}). La carte cadeau (–{{couponSaving}}) a été supprimée.',
      promo_no_saving: '{{points}} points appliqués (–{{pointsSaving}}). Le code promo {{name}} a été supprimé.',
      gift_no_saving: '{{points}} points appliqués (–{{pointsSaving}}). La carte cadeau a été supprimée.',
    },
  },
};
